import { IArticleDto } from './dtos'
import { IArticle } from './models'

export function mapArticleFromDto(dto: IArticleDto): IArticle {
	return {
		id: dto.id,
		title: dto.title,
		description: dto.teaser,
		content: dto.content,
	}
}
